"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Text = _interopRequireDefault(require("../Text/Text"));

var _DotMatrixChartDot = _interopRequireDefault(require("./DotMatrixChartDot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DotMatrixChart = function DotMatrixChart(_ref) {
  var items = _ref.items,
      onClickDot = _ref.onClickDot,
      noDataLabel = _ref.noDataLabel,
      props = _objectWithoutPropertiesLoose(_ref, ["items", "onClickDot", "noDataLabel"]);

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      textAlign: 'center'
    }
  }), items.length > 0 ? (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      mx: -2,
      flexWrap: 'wrap'
    }
  }, items.map(function (item) {
    return (0, _themeUi.jsx)("div", {
      key: item.id
    }, (0, _themeUi.jsx)(_DotMatrixChartDot["default"], {
      id: item.id,
      label: item.label,
      tooltipText: item.tooltipText,
      loading: item.loading,
      onClick: item.interactive ? item.onClick || onClickDot : null,
      size: 3,
      sx: {
        m: 2,
        bg: item.color,
        color: item.colorText
      }
    }));
  })) : (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      color: 'textMediumEmphasis',
      fontStyle: 'italic'
    }
  }, noDataLabel));
};

DotMatrixChart.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    label: _propTypes["default"].string,
    tooltipText: _propTypes["default"].string,
    color: _propTypes["default"].string,
    colorText: _propTypes["default"].string,
    interactive: _propTypes["default"].bool,
    onClick: _propTypes["default"].func
  })),
  onClickDot: _propTypes["default"].func,
  noDataLabel: _propTypes["default"].string
};
DotMatrixChart.defaultProps = {
  items: [],
  noDataLabel: '(No data available)'
};
var _default = DotMatrixChart;
exports["default"] = _default;